import { DATE_FORMAT } from "config";
import dayjs from "dayjs";

export const formatOperationTime = (startDate?: string, endDate?: string) => {
  return `${startDate ? dayjs(startDate).format(DATE_FORMAT) : ""} - ${
    endDate ? dayjs(endDate).format(DATE_FORMAT) : ""
  }`;
};
